export interface IDisposable {
    dispose () : void;
}

export function disposableScope<DISPOSABLE extends IDisposable, RETURN_VALUE> (
    disposable: DISPOSABLE, scopeFunc: (disposable: DISPOSABLE) => RETURN_VALUE
) : RETURN_VALUE {
    try {
        return scopeFunc(disposable);
    } finally {
        disposable.dispose();
    }
}

export async function disposableScopeAsync<DISPOSABLE extends IDisposable, RETURN_VALUE> (
    disposable: DISPOSABLE | (Promise<DISPOSABLE>), scopeFunc: (disposable: DISPOSABLE) => Promise<RETURN_VALUE>
) : Promise<RETURN_VALUE> {

    const resolvedDisposable = await disposable;

    try {
        return (await scopeFunc(resolvedDisposable));
    } finally {
        resolvedDisposable.dispose();
    }
}

export function disposableDisposeAll (disposables: IDisposable[]) {
    disposables.forEach(disposable => disposable.dispose());
}